export const dataWorks = [
  {
    name: "Academia Internacional de Periodismo-Comunicación Global",
    description:
      "This project delivers a modern, responsive, and performance-optimized website built using the latest technologies such as React 19, Vite, TailwindCSS 4, Redux Toolkit, and framer-motion. It also supports dynamic forms using EmailJS.",
    deploy: "https://acinpecg.com/",
    linkGitLub: "https://github.com/MartFrida/acinpeg",
  },
  {
    name: "Centro de Entrenadores Personales",
    description:
      "Utilizing React, JS, Tailwind, Docker, Node.js, Express, openai, with deployment on Render.",
    deploy: "https://cieptis-docker.onrender.com/",
    linkGitLub: "https://github.com/MartFrida/cieptis-docker-junto-deploy",
  },
  {
    name: "Backend for Articles Blog, Authorization",
    description:
      "Utilizing MongoDB, Mongoose, JOI, Express, Cloudinary, Morgan, Multer, and Bcrypt for development, with deployment handled on Render.",
    deploy: "https://articles-backend-s49f.onrender.com",
    linkGitLub: "https://github.com/MartFrida/articles-backend",
  },
  {
    name: "Articles Blog with Authorization",
    description:
      "Utilizing 'Backend for Articles Blog', and React, JS, Reduxjs, axios, redux-persist, react-router-dom, react-hook-form, TilewindCSS for development, with deployment handled on Netlify",
    linkNetlify: "https://article-blog-frontend.netlify.app/",
    linkGitLub: "https://github.com/MartFrida/articles-frontend",
  },
  {
    name: "Money Guard App",
    description:
      "Application for tracking expenses and income. Used React, Redux, JS",
    linkNetlify: "https://martfrida.github.io/project-CodeCrafters/",
    linkGitLub: "https://github.com/MartFrida/project-CodeCrafters",
  },
  {
    name: "Rental Car App",
    description:
      "This application is for the car rental service in Ukraine. Used React, Redux, JS, axios, vite",
    linkNetlify: "https://rentalcar-service.netlify.app/",
    linkGitLub: "https://github.com/MartFrida/rental-car-for-you",
  },
  {
    name: "Book Palace",
    description:
      "Utilizing React, JS, Tailwind, Netlify, GoogleDrive, EmailJS",
    deploy: "https://book-palace.netlify.app/",
    linkGitLub: "https://github.com/MartFrida/books-club",
  },
  {
    name: "Things store",
    description:
      "Using React, Tailwindcss, react-router-dom, bootstrap, react hooks",
    linkNetlify: "https://ec-react.netlify.app/",
    linkGitLub: "https://gitlab.com/mart.frida/ec-react",
  },
  {
    name: "Multistep form with rules",
    description: "Using React, Typescript, React-bootstrap, React hooks",
    linkNetlify: "https://mf-multistep-form.netlify.app/",
    linkGitLub: "https://gitlab.com/mart.frida/multistep-form-react",
  },
  {
    name: "Calculator",
    description:
      "Created simple calculator with react. Using react-Textfit, package manager:yarn, hooks: useState, createComponent, useComponent",
    linkNetlify: "https://calculator-reacthooks-textfit.netlify.app/",
    linkGitLub: "https://gitlab.com/mart.frida/calculator-react",
  },
  {
    name: "Quote Machine",
    description:
      "Created quote machiine with using React, Bootstrap, react-hooks:useState",
    linkNetlify: "https://quotemachine-react.netlify.app/",
    linkGitLub: "https://gitlab.com/mart.frida/quotaschange",
  },
];